import * as _ from "lodash-es";
import React, { ChangeEvent, Component } from "react";
import ContextEnum from "../../../models/ContextEnum";
import IEmailQuoteDTO from "../../../models/DTO/IEmailQuoteDTO";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import INotification from "../../../models/INotification";
import IOrder from "../../../models/IOrder";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import OwButton from "../../shared/OwButton/OwButton";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import OwChips from "../../shared/OwChips/OwChips";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import "./EmailQuoteModal.scss";
import { Socket } from "socket.io-client";
import IUiSocketSetup from "../../../models/IUiSocketSetup";

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    quoteOrderModel: IOrder;
};

type State = {
    vendor: boolean;
    user: boolean;
    sendEmailActive: boolean;
    addlEmails: string[];
    addlEmail: string;
};

class EmailQuoteModal extends Component<Props, State> {
    sockets: IUiSocketSetup[] = [];

    constructor(props: any) {
        super(props);

        this.sockets = [
            { endpoint: EndpointsEnum.OrderOnEmailQuote, fn: this.onEmailQuote },
            { endpoint: EndpointsEnum.Notify, fn: this.notify },
        ];

        this.state = {
            vendor: true,
            user: false,
            sendEmailActive: false,
            addlEmails: [],
            addlEmail: "",
        };
    }

    componentDidMount(): void {
        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }
    }

    componentWillUnmount(): void {
        for (const socket of this.sockets) {
            this.props.socket.removeListener(socket.endpoint, socket.fn);
        }
    }

    notify = () => {
        this.setState({
            sendEmailActive: false,
        });
    };

    closeModal = () => {
        this.props.closeModalFn();
    };

    create = () => {};

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    updatedChipsFn = (emails: string | string[]) => {
        let updatedEmails: string[] = [];

        if (_.isString(emails)) {
            updatedEmails.push(emails);
        } else {
            updatedEmails = [...emails];
        }

        this.setState({
            addlEmails: updatedEmails,
        });
    };

    enterAddAddlEmail = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter" || e.keyCode === 13) {
            this.addAddlEmail();
        }
    };

    addAddlEmail = () => {
        const addlEmails = this.state.addlEmails;

        if (this.state.addlEmail.length) {
            addlEmails.push(this.state.addlEmail);
        }

        this.setState({
            addlEmails,
            addlEmail: "",
        });
    };

    sendEmail = () => {
        const emails: string[] = [];

        if (this.state.vendor) {
            emails.push(this.props.quoteOrderModel.Vendor!.email);
        }

        if (this.state.user) {
            emails.push(this.props.userModel.email);
        }

        if (this.state.addlEmails.length) {
            emails.push(...this.state.addlEmails);
        }

        const payload: IEmailQuoteDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            quoteOrderGuid: this.props.quoteOrderModel.guid,
            emails,
        };

        this.props.socket.emit(EndpointsEnum.OrderEmailQuote, payload);

        this.setState({
            sendEmailActive: true,
        });
    };

    onEmailQuote = () => {
        const notification: INotification = {
            message: "successfully_emailed_quote",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.closeModal();

        this.setState({
            sendEmailActive: false,
        });
    };

    render() {
        return (
            <div className={"EmailQuoteModal p-2"}>
                <div className={"w-100"} style={{ height: "2rem" }}>
                    <div className={"d-flex justify-content-between"}>
                        <OwTitle leftIconName={"fad fa-cloud-upload-alt"} title={"email_quote"} tag={"h3"} />
                        <div>
                            <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={this.closeModal} />
                        </div>
                    </div>
                </div>

                {this.props.quoteOrderModel.Vendor?.email ? (
                    <div className={"mt-5 mb-2"}>
                        <OwCheckbox
                            fn={this.handleChange}
                            name={"vendor"}
                            label={this.props.quoteOrderModel.Vendor?.email}
                            skipTranslate={true}
                            checked={this.state.vendor}
                            truthyVal={true}
                            falsyVal={false}
                        />
                    </div>
                ) : null}

                <div className={"mb-2 mt-2"}>
                    <OwCheckbox
                        fn={this.handleChange}
                        name={"user"}
                        label={this.props.userModel.email}
                        checked={this.state.user}
                        skipTranslate={true}
                        truthyVal={true}
                        falsyVal={false}
                    />
                </div>

                <div className={"mb-2 mt-2"}>
                    <OwLabel title={"addl_emails"} />
                    <div className={"d-flex"}>
                        <div className={"input-group"}>
                            <OwInputWrapper
                                name={"addlEmail"}
                                value={this.state.addlEmail}
                                fn={this.handleChange}
                                onKeyDownFn={this.enterAddAddlEmail}
                            />
                            <OwButton title={"add"} fn={this.addAddlEmail} />
                        </div>
                    </div>
                    <div>
                        <OwChips updatedFn={this.updatedChipsFn} context={ContextEnum.PRIMARY} chips={this.state.addlEmails} />
                    </div>
                </div>

                <div>
                    <OwButton title={"send"} fn={this.sendEmail} active={this.state.sendEmailActive} disableOnActive={true} />
                </div>
            </div>
        );
    }
}

export default EmailQuoteModal;
